import { computed } from 'vue';

import { KitchenTicket, KitchenTicketItem } from 'app-core';

export type Item = {
  category_id: number;
  count: number;
  id: number;
  name: string;
}

export type Category = {
  name: string;
  id: number;
  items: Item[];
}

const useKitchenTicketItems = () => {
  // P15/P16 (owner 2026-07-10): all-day rows are PLAIN — the 8-tone item
  // color cycling was retired; the drawer selection highlights on the
  // accent tint instead.
  const round = (number: number, precision = 0) => {
    const factor = Math.pow(10, precision);

    return Math.round(number * factor) / factor;
  };

  const tickets = computed(() => {
    const allTickets = KitchenTicket.all();
    return allTickets.filter((ticket) => ticket.isPending());
  });

  const categoryItemsMap = computed(() => {
    const map = new Map();

    tickets.value.forEach((ticket) => {
      ticket.items.forEach((item: KitchenTicketItem) => {
        //if (item.completed_at) return; // TODO: Check if this is needed

        const itemId = item.product_id;
        const categoryName = item.getCategory()?.name || '';

        if (!map.has(categoryName)) {
          map.set(categoryName, []);
        }

        const existingItems = map.get(categoryName);

        const existingItem = existingItems.find((existing: Item) => existing.id === itemId);

        if (!existingItem) {
          existingItems.push({
            id: itemId,
            name: item.name,
            count: round(parseInt(item.count), 2),
            category_id: item.getCategory()?.id,
          });
        } else {
          existingItem.count += round(parseInt(item.count), 2);
        }
      });
    });

    return map;
  });

  const allItems = computed(() => {
    const result: Category[] = [];

    categoryItemsMap.value.forEach((items) => {
      result.push(...items);
    });

    return result;
  });

  const allItemsAndCategories = computed(() => {
    const result: Category[] = [];

    categoryItemsMap.value.forEach((items, name) => {
      result.push({
        name: name,
        id: items[0].category_id,
        items: items,
      });
    });

    return result;
  });

  return {
    allItemsAndCategories,
    allItems,
  };
};

export default useKitchenTicketItems;
